import React from 'react';
import { useSelector } from 'react-redux';
import ArrowRightIcon from 'assets/svg/arrow-right.svg';
import BackLink from 'components/navigation/BackLink';
import { ShowAt } from 'consts/breakpoints';
import { Text } from 'ds/components/typography';
import { HeaderWrapper, TabHeader, TabsHeaderWrapper } from './styled';
import { useLocale } from 'locale';
import { Route, useRoute } from 'config/routes';
import { savedSearchesCountSelector } from 'store/state/selectors/savedSearchPage';
import { userFavoritesSlimCounterSelector } from 'store/state/domainData/selectors/favorites';

type FavoritesRoutes = Route.SavedSearchesPage | Route.Shortlist;

interface FavoritesSubheaderProps {
  currentRoute: FavoritesRoutes;
}

const routeList: FavoritesRoutes[] = [ Route.Shortlist, Route.SavedSearchesPage ];

export const FavoritesSubheader: React.FC<FavoritesSubheaderProps> = ({ currentRoute }) => {
  const { t } = useLocale();
  const { route, router } = useRoute();
  const savedSearchesCount = useSelector(savedSearchesCountSelector);
  const favoritesCount = useSelector(userFavoritesSlimCounterSelector);

  const routeCounts: Record<FavoritesRoutes, number> = {
    [Route.SavedSearchesPage]: savedSearchesCount,
    [Route.Shortlist]: favoritesCount,
  };

  const navigateToRoute = (routeName: FavoritesRoutes) => {
    router.navigate(routeName, route.params, { replace: true });
  };

  return (
    <>
      <ShowAt from={2}>
        <HeaderWrapper>
          <div data-auto="back-button">
            <BackLink>
              <ArrowRightIcon width={24} height={24} />
            </BackLink>
          </div>
          <Text>
            {t('savedSearch.titleV2')}
          </Text>
          <div />
        </HeaderWrapper>
      </ShowAt>
      <TabsHeaderWrapper>
        {routeList.map((routeName) => (
          <TabHeader key={routeName} onClick={() => navigateToRoute(routeName)} isActive={currentRoute === routeName}>
            <Text data-auto={`tab-${routeName}`}>
              {t('savedSearch.tabs', { tab: routeName })}
              {routeCounts[routeName] ? ` (${routeCounts[routeName]})` : ''}
            </Text>
          </TabHeader>
        ))}
      </TabsHeaderWrapper>
    </>
  );
};
